const $document = $(document);

const globalCurrencyCodeUrl = `${window.location.origin}/settings/currencyCode`;

let changingCurrency = false;
function currencySelectorInit() {
    $(function () {
        $document.on("change", ".js-globalCurrencySelector", function (e) {
            if (changingCurrency) {
                return;
            }

            const currencyCode = $(this).val();
            const data = {
                currencyCode: currencyCode,
            }

            $.post(globalCurrencyCodeUrl, data, "json")
                .then(function () {

                    // Change all instances of currency selector to selected currency.
                    // To do so we need to call .trigger("change") so it updates the select2 instances.
                    // But to prevent calling this function again, we have the `changingCurrency` variable in place.
                    changingCurrency = true;
                    $(".js-globalCurrencySelector")
                        .val(currencyCode)
                        .trigger('change') // so it's populated over to all select2 instances
                    ;

                    // Finally reload the page.
                    window.location.reload();
                }, function (response) {
                    if (response.hasOwnProperty("responseJSON") && response.responseJSON.hasOwnProperty("message")) {
                        alert(`Failed to change currency. Error: ${response.responseJSON.message}`);
                    } else {
                        alert("Failed to change currency.");
                    }
                });
        });
    });
}
export default currencySelectorInit